import { render, staticRenderFns } from "./UnreadMessageIconColored.vue?vue&type=template&id=39eb1502"
import script from "./UnreadMessageIconColored.vue?vue&type=script&lang=js"
export * from "./UnreadMessageIconColored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports